import { buildManageRouteWithSchoolYear } from './manageSchoolYearRouting';
import { normalizeSchoolYearStartYear } from '../common/schoolYear';

export function buildStudentClassRoute(row, studentId, originYear, originSearch = '') {
  if (!row.canOpenDetails || !row.schoolClassId || normalizeSchoolYearStartYear(row.schoolYearStart) !== row.schoolYearStart) return null;
  const params = new URLSearchParams(originSearch);
  const search = params.get('returnTo') === 'students' ? '?returnTo=students' : '';
  return {
    ...buildManageRouteWithSchoolYear(`/manage/class/${encodeURIComponent(row.schoolClassId)}`, '', row.schoolYearStart),
    state: { from: buildManageRouteWithSchoolYear(`/manage/student/${encodeURIComponent(studentId)}`, search, originYear) },
  };
}

export function readStudentClassReturnRoute(from) {
  if (!from || typeof from !== 'object' || typeof from.pathname !== 'string' || !/^\/manage\/student\/[^/?#]+$/.test(from.pathname)) return null;
  const params = new URLSearchParams(from.search || '');
  const year = Number(params.get('schoolYearStart'));
  if (!/^\d{4}$/.test(params.get('schoolYearStart')) || normalizeSchoolYearStartYear(year) !== year) return null;
  return buildManageRouteWithSchoolYear(from.pathname, params.get('returnTo') === 'students' ? '?returnTo=students' : '', year);
}

export function buildSchoolClassReturnRoute(from, search, activeYear) {
  const studentReturn = readStudentClassReturnRoute(from);
  if (studentReturn) return studentReturn;
  // Existing attendance links supply pathname + search as a string.
  if (typeof from === 'string' && /^\/manage\/[^#\\\s]*$/.test(from)) {
    const queryAt = from.indexOf('?');
    const pathname = queryAt < 0 ? from : from.slice(0, queryAt);
    const sourceSearch = queryAt < 0 ? search : from.slice(queryAt);
    return buildManageRouteWithSchoolYear(pathname, sourceSearch, activeYear);
  }
  return buildManageRouteWithSchoolYear('/manage/classes', search, activeYear);
}
